<script>
    import {
        getStatusByStep,
        ProgressBarItemStatus,
    } from './ProgressBarHelpers.svelte';
    import { store } from '../Store.svelte';
    import { navigate } from 'svelte-routing';

    export let stepIndex;
    export let stepText;
    export let href;

    export let currentStep;

    let itemElement;

    $: currentStatus = getStatusByStep(currentStep, stepIndex);
    $: if (currentStatus === ProgressBarItemStatus.ACTIVE) {
        // Wait for the element to be in the DOM
        setTimeout(() => {
            itemElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }, 100);
    }

    function handleClick() {
        if (!href) return;
        if (currentStatus !== ProgressBarItemStatus.COMPLETED) return;
        navigate(href, { replace: false });
    }
</script>

<button
    bind:this={itemElement}
    on:click={handleClick}
    disabled={currentStatus === ProgressBarItemStatus.PENDING ||
        currentStep === 7}
    class="progress-step {currentStatus === ProgressBarItemStatus.COMPLETED
        ? 'progress-step--complete'
        : currentStatus === ProgressBarItemStatus.ACTIVE
          ? 'progress-step--active'
          : ''}"
>
    <span class="step-num" class:step-num-blue={$store.requestedServices.isSky}
        ><span class="num" class:blue-dark-text={$store.requestedServices.isSky}
            >{stepIndex}</span
        >
        <span class="check"
            ><img src="/assets/img/icons/check-dark.svg" alt="" /></span
        ></span
    >
    <span
        class="step-text"
        class:blue-dark-text={$store.requestedServices.isSky}>{stepText}</span
    >
</button>
